import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CompetencyData } from "src/app/Models/competencyModel.model";
import { SharedcompetencyService } from "src/app/services/sharedcompetency.service";
import { CompetenciesService } from "./competencies.service";
import { CircleProgressComponent, CircleProgressOptions } from 'ng-circle-progress';
@Component({
  selector: "app-competencies",
  template: "<router-outlet></router-outlet>",
})
export class CompetenciesComponent implements OnInit {
  title: string;
  public subCompetencies: any;
  public data: any;
  public gridData: any;
  public competencyData: CompetencyData = new CompetencyData();
  public loader: boolean = false;
  kpi=['project','data']
  public randomText: string = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`;
  constructor(
    private _service: CompetenciesService,
    private _router: Router,
    private _sharedService: SharedcompetencyService
  ) {}

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: "25px",
    infinite: true,
    responsive: [
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          focusOnSelect: false,
          swipe: true
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true
        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true
        },
      },
    ],
    nextArrow: '<button class="slick-next">Next</button> ',
    prevArrow: '<button class="slick-prev">Previous</button>',
  };

  ngOnInit() {
    this.loadInitialData();
    this.editfilter();
    this.getsettingsbyid();
  
  }
  loadInitialData() {
    this.title = "Competencies";
    this.loader = true;
    this._service.getCompetencies().subscribe((res) => {
      this.data = res.data;
      this.data.map((practice) => {
        practice.description = this.randomText;
      });
      this.loader = false;
    });
  }


  getsettingsbyid() {
    this._service.GetSettings(parseInt(localStorage.getItem('Id'))).subscribe((res) => {
      this.data = res.data;
      this.processData();   
    });
  
  }
  
  processData() {
    
  }

  editfilter(){
    const kpidata={
      "employeeId": parseInt(localStorage.getItem('Id')),
     "kpIs": [
    "projectData","Tasks","Data"
       ],
    "widgets": [
    "certifications"
      ]
    }    
  }
  
  getSubCompetencies(data: any) {
    this.competencyData.competencyId = data.id;
    this.competencyData.competencyName = data.name;
  }

  getSubCompetencyDetails(data: any) {
    this.competencyData.subCompetencyId = data.id;
    this.competencyData.subCompetencyName = data.name;
    this.competencyData.subCompetencyLeader = data.leader;
    this._sharedService.sendMessage(this.competencyData);
    this._router.navigate([
      `/competency/${this.competencyData.competencyId}/subcompetency/${data.id}/`,
    ]);
  }

  
}
